import React, { useEffect, useState } from "react";
import { Button, Table, Modal, Empty } from "antd";
import { ArrowRightOutlined, LoadingOutlined } from "@ant-design/icons";
import { get_language, translate } from "../../locale";
import EmailServices from "../../services/EmailServices";
import moment from "moment-timezone";
import { useParams } from "react-router-dom";

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

const EmailsTable = (props) => {
  const { reload } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [modalDetails, setModalDetails] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const { username, days } = useParams();

  const columns = [
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="flex space-x-4 justify-center">
          <Button
            type="text"
            icon={<ArrowRightOutlined />}
            size="small"
            className="border-0"
            onClick={() => handleShowDetails(record)}
          />
        </div>
      ),
      width: 100,
    },
    {
      title: translate("Fecha"),
      dataIndex: "date",
      key: "date",
      render: (_, record) =>
        moment(record.register_date)
          .tz("UTC")
          .format(get_language === "en" ? "MM/DD/YYYY" : "DD/MM/YYYY"),
      sorter: (a, b) => {
        if (a.register_date < b.register_date) return -1;
        if (a.register_date > b.register_date) return 1;
        return 0;
      },
    },
    {
      title: translate("Remitente"),
      dataIndex: "sender",
      key: "sender",
      render: (_, record) => record.sender.username,
      sorter: (a, b) => {
        if (a.sender.username < b.sender.username) return -1;
        if (a.sender.username > b.sender.username) return 1;
        return 0;
      },
    },
    {
      title: translate("Título"),
      dataIndex: "subject",
      key: "subject",
      render: (_, record) => record.email.subject,
      sorter: (a, b) => {
        if (a.email.subject < b.email.subject) return -1;
        if (a.email.subject > b.email.subject) return 1;
        return 0;
      },
    },
  ];

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (reload !== null) {
      loadData();
    }
  }, [reload]);

  const loadData = async () => {
    setLoading(true);
    try {
      const res = await EmailServices.getEmails(username, days);
      if (res.status >= 200 && res.status < 300 && res.data.data.length > 0) {
        setData(res.data.data);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleShowDetails = (data) => {
    setModalDetails(true);
    setSelectedData(data);
  };

  const handleHideDetails = () => {
    setModalDetails(false);
  };

  return (
    <>
      <Table
        rowKey={(i) => {
          return i.id.toString();
        }}
        dataSource={data}
        columns={columns}
        loading={
          loading
            ? { indicator: antIcon, className: "text-custom_blue" }
            : false
        }
        locale={{
          emptyText: <Empty description={translate("No hay datos")} />,
          sortTitle: translate("Ordenar"),
          triggerDesc: translate("Ordenar (descendente)"),
          triggerAsc: translate("Ordenar (ascendente)"),
          cancelSort: translate("Cancelar orden"),
        }}
      />
      <Modal
        open={modalDetails}
        title={translate("Notificación")}
        onCancel={handleHideDetails}
        footer={[
          <Button key="ok" type="primary" onClick={handleHideDetails}>
            {translate("Aceptar")}
          </Button>,
        ]}
      >
        {selectedData !== null && (
          <>
            <p>
              <strong>{translate("Fecha")}: </strong>{" "}
              {moment(selectedData.register_date)
                .tz("UTC")
                .format(
                  get_language === "en"
                    ? "MM/DD/YYYY HH:mm:ss"
                    : "DD/MM/YYYY HH:mm:ss"
                )}
              <br />
              <strong>{translate("Remitente")}: </strong>{" "}
              {selectedData.sender.username}
              <br />
              <strong>{translate("Título")}: </strong>{" "}
              {selectedData.email.subject}
              <br />
              <strong>{translate("Descripción")}: </strong>{" "}
            </p>
            <div
              dangerouslySetInnerHTML={{
                __html: selectedData.email.body,
              }}
            ></div>
          </>
        )}
      </Modal>
    </>
  );
};

export default EmailsTable;
